import { ROUTES } from "@/constants/routes";
import { ADMINISTRATION_TAB_KEYS } from "@/features/Administration";
import { SIDEBAR_KEYS } from "@/layout/MainLayout";

import { TUserConfig } from "./Auth.types";

export const ACCOUNT_PLAN_TYPES = {
  TRIAL: "trial",
  PAID_PLAN_A: "paidPlanA",
  PAID_PLAN_B: "paidPlanB",
} as const;

export const ACCOUNT_TYPES = {
  TEKIL: "tekil",
  EMS: "ems",
} as const;

export const USER_ROLES = {
  ADMIN: "admin",
  GUEST: "guest",
  SUPERVISOR: "supervisor",
} as const;

export const USER_STATUSES = {
  INVITED: "invited",
  CONFIRMED: "confirmed",
} as const;

export const ONBOARDING_STATUSES = {
  INCOMPLETE: "incomplete",
  COMPLETED: "completed",
} as const;

export const USER_TYPES = {
  SENSOR: "sensor",
  OSOS: "osos",
  ALL: "all",
} as const;

// NOTLAR:

// 1. divider'ı da doğru görünüm için hiddenSidebarItems'a eklendi. Buna dikkat edilmeli. Yoksa birden fazla divider görünümü ile karşılaşılacaktır.

// 2. mainPage nedir? Anasayfa kullanıcı tipine göre değişebilir(bknz: sensör kullanıcısı), bu yüzden anasayfaya yönlendirme yapılan yerlerde sorun olmaması için bu property eklendi.

// 3. hiddenSidebarItems nedir? Sidebar'da gizlemek istenen keyler buarada tanımlanır. Bunun kontrolü main layout içerisindeki sidebar component'ında kontrol ediliyor.

// 4. hiddenRoutes nedir? Kullanıcı tipine göre erişimi kısıtlanan sayfalar burada tanımlanır. Protected Route component'ı içinde bu tanımlamalara uygun biçimde yönlendirmeler gerçekleşir.

export const USER_CONFIGS: Record<string, TUserConfig> = {
  [USER_TYPES.ALL]: {
    mainPage: ROUTES.DASHBOARD,
  },
  [USER_TYPES.OSOS]: {
    mainPage: ROUTES.DASHBOARD,
    hiddenSidebarItems: [
      SIDEBAR_KEYS.SMART_DEVICES, SIDEBAR_KEYS.SMART_DEVICES_DIVIDER,
    ],
    hiddenRoutes: [
      ROUTES.SENSORS,
      ROUTES.REPORTS,
      ROUTES.SENSOR_COMPARE,
    ],
  },
  [USER_TYPES.SENSOR]: {
    mainPage: ROUTES.SENSORS,
    hiddenRoutes: [
      ROUTES.DASHBOARD,
      ROUTES.OSOS_ONBOARDING,
      ROUTES.OSOS,
      ROUTES.BUDGET_PLANNING,
      ROUTES.TARIFFS,
      ROUTES.BILLINGS,
      ROUTES.BILLING_PREDICTION,
      ROUTES.MCP_PREDICTION,
      ROUTES.SUSTAINABILITY,
      ROUTES.GENERATION,
    ],
    hiddenSidebarItems: [
      SIDEBAR_KEYS.TOOLS,
      SIDEBAR_KEYS.TOOLS_DIVIDER,
      SIDEBAR_KEYS.PREDICTION,
      SIDEBAR_KEYS.PREDICTION_DIVIDER,
      SIDEBAR_KEYS.GENERATION,
    ],
    hiddenAdministrationTabs: [
      ADMINISTRATION_TAB_KEYS.OSOS_LIST, ADMINISTRATION_TAB_KEYS.BILLINGS,
    ],
  },
};

export const ELECTRIC_USER_CONFIGS: TUserConfig = {
  mainPage: ROUTES.DASHBOARD,
  hiddenRoutes: [
    ROUTES.ADMINISTRATION,
    ROUTES.DOCUMENTS,
    ROUTES.SENSORS,
    ROUTES.ALARMS,
    ROUTES.REPORTS,
    ROUTES.GENERATION,
    ROUTES.SENSOR_COMPARE,
    ROUTES.BILLINGS,
    ROUTES.BUDGET_PLANNING,
    ROUTES.TARIFFS,
    ROUTES.SUSTAINABILITY,
  ],
  hiddenSidebarItems: [
    SIDEBAR_KEYS.ALARMS,
    SIDEBAR_KEYS.GENERATION,
    SIDEBAR_KEYS.TOOLS,
    SIDEBAR_KEYS.TOOLS_DIVIDER,
    SIDEBAR_KEYS.DOCUMENTS,
    SIDEBAR_KEYS.DOCUMENTS_DIVIDER,
    SIDEBAR_KEYS.PREDICTION_DIVIDER,
    SIDEBAR_KEYS.SMART_DEVICES,
    SIDEBAR_KEYS.SMART_DEVICES_DIVIDER,
    SIDEBAR_KEYS.ADMINISTRATION,
  ],
};
